export const oldApiHosts = {
    publicAssets: 'https://gift-api-assets-public.azurewebsites.net',
    privateAssets: 'https://gift-api-assets-private.azurewebsites.net',
    functions: 'https://gift-editor-functions.azurewebsites.net'
};

export const newApiHosts = {
    publicAssets: 'https://api-assets-public.instantdesigntool.com',
    privateAssets: 'https://api-assets-private.instantdesigntool.com',
    functions: 'https://editor-functions.instantdesigntool.com'
};

export const replaceAzureUrlsWithIdtUrls = (project: any): any => {

    const pluginsToUpdate = ['photo', 'engraving', 'svg'];

    const variableIdsToUpdate = Object.keys(project.variables.entities)
        .filter(key => pluginsToUpdate.includes(project.variables.entities[key]!.pluginId));

    const result = {
        ...project,
        version: 'idt-urls'
    };

    const inputsToUpdate = Object.keys(project.inputs.entities)
        .filter(key => variableIdsToUpdate.includes(key))
        .filter(key => project.inputs.entities[key])
        .map(key => project.inputs.entities[key]!);

    for (const input of inputsToUpdate) {
        if (input.value.assetUrl) {
            result.inputs.entities[input.id]!.value.assetUrl = update(input.value.assetUrl);
        }
    }

    const variantsToUpdate = Object.keys(project.variants.entities)
        .filter(key => result.variants.entities[key]!.options.backgroundAssetUrl)
        .map(key => project.variants.entities[key]!);

    for (const variant of variantsToUpdate) {
        result.variants.entities[variant.id]!.options.backgroundAssetUrl
            = update(variant.options.backgroundAssetUrl);
    }

    return result;
};

const update = (source: string) => source
    .replace(oldApiHosts.privateAssets, newApiHosts.privateAssets)
    .replace(oldApiHosts.publicAssets, newApiHosts.publicAssets)
    .replace(oldApiHosts.functions, newApiHosts.functions);